angular.module('tf.directives')

    .directive('imageUploader', ['$compile','$timeout',
        function ($compile, $timeout) {
        return{
            restrict:'E',
            replace:true,
            scope:{
                url : '=',
                options: "=",
                menu : "=",
                api: "="
            },
            templateUrl:'js/components/imageUploader/imageUploader.html',
            transclude:true,
            controller:'UploadController',
            link: function(scope, element){
                angular.element(element[0].getElementsByClassName('file-upload-urlbox')[0]).bind("keydown keypress", function (event) {
                    if(event.which === 13) {
                        scope.$apply(function (){
                            scope.urlboxBlur();
                        });
                        event.preventDefault();
                    }
                });

                scope.menu = scope.menu || {};
                scope.api = scope.api || {};

                if(scope.options.lockAspect === "false"){
                    scope.options.lockAspect = false;
                }else if(scope.options.lockAspect === "true"){
                    scope.options.lockAspect = true;
                }

                scope.menu.isLockAspectAllowed = function () {
                    return !!scope.options.parentWidth && !!scope.options.parentHeight;
                };


                if(scope.options.lockAspect === true){
                    scope.options.lockAspect = scope.menu.isLockAspectAllowed();
                }

                scope.menu.isLockAspectForced = function(){
                    return _.isString(scope.options.lockAspect) && scope.options.lockAspect.toLowerCase() === "force";
                };


                scope.setDefaultCrop = function(){
                    scope.options.crop = {x0 : 0, y0 : 0, x1 : 1, y1 : 1};
                };


                var footage = $(element).find('.file-upload-preview .media-wrapper')[0];
                scope.footage = {width: footage.clientWidth, height : footage.clientHeight};


                new ResizeSensor(footage, function(){
                    scope.footage.width = footage.clientWidth;
                    scope.footage.height = footage.clientHeight;
                });


                if(scope.video){
                    scope.videoReady = function($API){
                        var videoElement = $(footage).find('video')[0];
                        videoElement.addEventListener('loadeddata', function() {
                            scope.footage.width = footage.clientWidth;
                            scope.footage.height = footage.clientHeight;
                            if(scope.menu.isLockAspectForced()) {
                                scope.options.isCrop = true;
                            }
                            if(scope.options.isCrop){
                                scope.showCropbox();
                            }

                        }, false);
                    };

                } else {
                    var imgElement = $(footage).find('img')[0];
                    imgElement.onload = function(){
                        $timeout(function(){
                            scope.menu.imageErr = false;
                        },0);
                        scope.footage.width = this.width;
                        scope.footage.height = this.height;
                        if(scope.menu.isLockAspectForced()) {
                            scope.options.isCrop = true;
                        }
                        if(scope.options.isCrop){
                            scope.showCropbox();
                        }
                    };
                    imgElement.onerror = function(){
                        scope.menu.imageErr = true;
                    }
                    ;

                }

                scope.showCropbox = function(){
                    scope.cropOptions = {
                        crop : scope.options.crop,
                        lockAspect : scope.options.lockAspect,
                        parentWidth : scope.options.parentWidth,
                        parentHeight : scope.options.parentHeight
                    };
                    var cropbox = angular.element('<cropbox image="footage" options="cropOptions" api="api"></cropbox>');
                    $(element).find('.file-upload-preview .media-wrapper').append(cropbox);
                    $compile(cropbox)(scope);
                    if(scope.options.lockAspect){
                        scope.api.resetCropLockAspect(true);
                    }
                };
                scope.hideCropbox = function(){
                    $(element).find('.cropbox').remove();
                };
                scope.menu.toggleCrop = scope.toggleCrop = function(){
                    if(scope.options.isCrop){
                        scope.hideCropbox();
                    } else {
                        scope.showCropbox();

                        if(scope.options.lockAspect){
                            scope.api.resetCropLockAspect();
                        }
                    }
                    scope.options.isCrop = !scope.options.isCrop;
                };

                scope.menu.toggleCropLockAspect = function(){
                    if(scope.options.isCrop){
                        scope.options.lockAspect = scope.cropOptions.lockAspect = !scope.cropOptions.lockAspect;

                        if(scope.cropOptions.lockAspect) {
                            scope.api.resetCropLockAspect();
                        }
                    }
                };
            }
        };
    }])

    .controller('UploadController', ['$scope', 'Upload', 'cloudinary','$compile','$element','$stateParams', '$timeout', 'NotificationService', 'FileUploadService', 'Session',
        /* Uploading with Angular File Upload */
        function($scope, $upload, cloudinary, $compile, $element, $stateParams, $timeout, NotificationService, FileUploadService, Session) {
            var maxFileSize = 100;
            $scope.maxFileSizeStr = maxFileSize + "MB";
            var d = new Date();

            $scope.videoTypes = ['avi', 'mpg', 'mpeg', 'mov', 'mp4', 'wmv'];
            $scope.imageTypes = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif', 'tiff', 'tga', 'ico'];
            $scope.isInit=true;
            $scope.title = "Image (" + d.getDate() + " - " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds() + ")";


            Session.whenReady().then(function(){
                maxFileSize = Session.user.getFarm().farm.plan.upload_limit || 100;
                $scope.maxFileSizeStr = maxFileSize + "MB";
            });

            function onProgress(e){
                $scope.isInit=false;
                delete $scope.thumbnail;
                delete $scope.menu.url;
                $scope.progress = Math.round((e.loaded * 100.0) / e.total);

            }
            function onSuccess(cdnUrl){
                return function(){
                    $scope.menu.url = $scope.url = cdnUrl;
                    $scope.options.size = $scope.originalSize;

                    $scope.video = cdnUrl;
                    $scope.options.valueType = 'video';

                    delete $scope.progress;
                    FileUploadService.isUploading = false;
                };

            }

            function onError(data){
                // if(file){file.result = data;}
                console.log(data);
                $scope.isInit = true;
                delete $scope.progress;
                delete $scope.url;
                $scope.options.size = $scope.originalSize;
                FileUploadService.isUploading = false;

            }

            function upload(file, url){
                return $upload.http({
                    url: url,
                    method  : 'PUT',
                    headers : {
                        'Content-Type' : file.type
                    },
                    data    : file
                });
            }

            function s3upload(file){
                FileUploadService.isUploading = true;
                if (file && !file.$error) {
                    FileUploadService.getPresignedUrl(randomName(file), file.type, false).then(function (s3Urls) {
                        var s3UploadUrl = s3Urls.uploadUrl;
                        var cdnUrl = s3Urls.cdnUrl;
                        upload(file, s3UploadUrl)
                            .progress(onProgress)
                            .success(onSuccess(cdnUrl))
                            .error(onError);
                    });
                }
            }

            function randomName(file){
                return uuid() + '.' + file.name.split('.')[1];
            }

            $scope.uploadFile = function(file){
                if (file && !file.$error) {
                    FileUploadService.isUploading = true;
                    $scope.originalSize = $scope.options.size;
                    $scope.options.size = 2;
                    $scope.url = "https://www.templatefarm.io/img/test-pattern.jpg";
                    if(false && isVideo(file.name)){
                        s3upload(file);
                    } else {
                        file.upload = $upload.upload({
                            url: "https://api.cloudinary.com/v1_1/" + cloudinary.config().cloud_name + "/upload",
                            data: {
                                upload_preset: cloudinary.config().upload_preset,
                                //tags: 'myphotoalbum',
                                //context: 'photo=' + $scope.title,
                                file: file
                            }
                        })
                        .progress(onProgress)
                        .success(function (data) {
                            data.context = {custom: {photo: $scope.title}};
                            file.result = data;
                            $scope.menu.url = $scope.url = file.result.secure_url || file.result.url;
                            $scope.options.size = $scope.originalSize;
                            if(data.resource_type === 'video'){
                                if(data.is_audio){
                                    $scope.thumbnail = getWaveformUrl(data.secure_url || data.url, data.format);
                                    $scope.options.valueType = 'audio';
                                } else {
                                    $scope.video = data.url;
                                    $scope.options.valueType = 'video';
                                    $scope.videoThumbnail = changeFormat(data.secure_url || data.url, data.format, 'jpg');
                                }
                            } else if (data.resource_type === 'image'){
                                $scope.thumbnail = getThumbnailUrl(file.result.secure_url || file.result.url, data.format, 800);
                                $scope.options.valueType = 'image';
                            } else {
                                $scope.thumbnail = file.result.secure_url || file.result.url;
                            }
                            delete $scope.progress;
                            FileUploadService.isUploading = false;
                        }).error(onError);
                    }
                }
            };

            $scope.popup = function (file){
                var fileSize = parseFloat(file.size / 1000000).toFixed(2) + "MB";
                if(file.$error === "maxSize"){
                    NotificationService.popup('info-popup', {title: 'File size limit',
                        content: 'The file \"' + file.name +'\"' + ' size is '+ fileSize + '.<br/>' + 'Maximum allowed size is ' + $scope.maxFileSizeStr
                    });
                }
            };
            function changeFormat(url, currentFormat, newFormat){
                return url.replace('.' + currentFormat, '.' + newFormat);
            }

            function getWaveformUrl(url, currentFormat){
                var index = url.indexOf('upload/') + 7;
                var waveformColor = 'rgb:515151';
                var backgroundColor = 'white';
                var width = 500;
                var height = 200;
                return changeFormat(url.slice(0,index) + "h_"+ height +",w_"+ width +",co_"+ waveformColor +",b_"+ backgroundColor +",fl_waveform/" + url.slice(index), currentFormat, 'png');
            }
            function getThumbnailUrl(url, currentFormat, width){
                var index = url.indexOf('upload/') + 7;
                // return changeFormat(url.slice(0,index) + "c_limit,w_"+ width + "/" + url.slice(index), currentFormat, 'jpg');
                return changeFormat(url.slice(0,index) + "c_limit,w_"+ width + "/" + url.slice(index), currentFormat, (currentFormat === 'jpg' ? currentFormat : 'png'));// Fix for png thumbnail
            }

            var isDemo = $scope.isDemo = function () {
                return !!$stateParams.demo;
            };

            /* Modify the look and fill of the dropzone when files are being dragged over it */
            $scope.dragOverClass = function($event) {
                var items = $event.dataTransfer.items;
                var hasFile = false;
                if (items !== null) {
                    for (var i = 0 ; i < items.length; i++) {
                        if (items[i].kind == 'file') {
                            hasFile = true;
                            break;
                        }
                    }
                } else {
                    hasFile = true;
                }
                return hasFile ? "dragover" : "dragover-err";
            };

            $scope.menu.clearUpload = $scope.clearUpload = function() {
                NotificationService.popup('confirm-general', {
                    title: 'Remove',
                    content: 'Are you sure you want remove the media ?',
                    onConfirm : function(){
                        delete $scope.url;
                        delete $scope.customURL;
                        delete $scope.thumbnail;
                        delete $scope.video;
                        delete $scope.menu.url;

                        $scope.isInit = true;

                        $scope.options.size = 2;
                        $scope.setDefaultCrop();
                        $scope.options.isCrop = false;
                        $scope.hideCropbox();
                        delete $scope.options.valueType;
                        delete $scope.options.videoThumbnail;
                        delete $scope.options.useAudio;
                    }
                });
            };

            $scope.urlboxClick = function(){
                event.stopPropagation();
            };
            $scope.urlboxBlur = function(loadedFromTemplate){
                if(isValidURL($scope.customURL)){
                    $scope.isInit=false;
                    $scope.menu.url = $scope.customURL;
                    if(!loadedFromTemplate){
                        $scope.url = $scope.customURL;
                    }
                    if(isVideo($scope.customURL)){
                        $scope.video = $scope.customURL;
                        $scope.options.valueType = 'video';
                        $scope.options.videoThumbnail = "https://www.templatefarm.io/img/test-pattern.jpg";
                    } else {
                        $scope.thumbnail = $scope.customURL;
                        $scope.options.valueType = 'image';
                    }

                }
            };
            function isVideo(url){
                return url.endsWith(".mp4") ||
                    url.endsWith(".avi") ||
                    url.endsWith(".flv") ||
                    url.endsWith(".mov") ||
                    url.endsWith(".mpg") ||
                    url.endsWith(".mpeg") ||
                    url.endsWith(".wmv")  ;
            }

            function isValidURL(str){
                var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
                var pattern = new RegExp(expression);
                return(pattern.test(str));
            }

            function setTumbnail(){
                if($scope.url){
                    if($scope.url.indexOf('cloudinary') !== -1 && !isVideo($scope.url)){
                        var extension = $scope.url.slice($scope.url.lastIndexOf('.') + 1);
                        $scope.customURL = getThumbnailUrl($scope.url, extension, 800);
                    } else {
                        $scope.customURL = $scope.url;
                    }
                    $scope.urlboxBlur(true);
                }
            }
            setTumbnail();

        }])

;
